import { Layout, Spin, Drawer } from "antd";
import { IssueDetailHeader, ProjectsHeader } from "components/module";
import SponsorHeader from "components/module/sponsorHeader";
import Seo from "pages/seo";
import { FC, memo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTER_CONSTANTS } from "utils/constant";
import Breadcrumb from "../breadcrumb";
import FooterUser from "../footer";
import HeaderUser from "../header";
import SidebarProjects from "../sidebarProjects";
import { IMasterLayoutProps } from "./masterLayout.props";
import {
  AppFooter,
  Container,
  SpinContainer,
  MobileSidebarTrigger,
} from "./masterLayout.style";
import { AlignLeftOutlined } from "@ant-design/icons";

const { Sider, Content } = Layout;

const MasterLayout: FC<IMasterLayoutProps> = ({
  children,
  showSidebarProjects,
  showHeaderProjects,
  showHeaderIssueDetail,
  isFluid,
  isFullWidth,
  isLoading,
  breadcrumb,
  loadingBreadcrumb,
  setRefetchAboutPage,
  showHeaderSponsor,
  customHeader,
  ...props
}: IMasterLayoutProps) => {
  const navigate = useNavigate();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const bgBody = "#FFFFFF";

  return (
    <Layout style={{ background: bgBody }} {...props}>
      <Seo />
      <HeaderUser
        onClickSignUp={() => navigate(ROUTER_CONSTANTS.USER.SIGNUP)}
        onClickLogIn={() => navigate(ROUTER_CONSTANTS.USER.LOGIN)}
      />
      {breadcrumb && breadcrumb.length > 0 && (
        <Breadcrumb items={breadcrumb} loading={loadingBreadcrumb} />
      )}

      {showHeaderIssueDetail && <IssueDetailHeader />}

      {showHeaderProjects && (
        <ProjectsHeader setRefetchAboutPage={setRefetchAboutPage} />
      )}

      {showHeaderSponsor && <SponsorHeader />}

      {customHeader}

      <Container $isFluid={isFluid} $isFullWidth={isFullWidth}>
        {isLoading ? (
          <SpinContainer>
            <Spin />
          </SpinContainer>
        ) : (
          <Layout style={{ background: bgBody }}>
            {showSidebarProjects && (
              <>
                {/* Desktop Sidebar */}
                <Sider
                  width={300}
                  style={{ background: bgBody }}
                  breakpoint="xl"
                  collapsedWidth="0"
                  className="desktop-sidebar"
                  onBreakpoint={(broken) => {
                    // Optional: handle breakpoint change if needed
                  }}
                  trigger={null}
                >
                  <SidebarProjects />
                </Sider>

                <style>{`
                  @media (max-width: 1200px) {
                    .desktop-sidebar {
                      display: none !important;
                    }
                  }
                `}</style>

                {/* Mobile Sidebar Trigger & Drawer */}
                <MobileSidebarTrigger
                  onClick={() => setMobileSidebarOpen(true)}
                >
                  <AlignLeftOutlined /> Menu
                </MobileSidebarTrigger>
                <Drawer
                  title="Project Menu"
                  placement="left"
                  onClose={() => setMobileSidebarOpen(false)}
                  visible={mobileSidebarOpen}
                  width={300}
                  bodyStyle={{ padding: 0 }}
                >
                  <SidebarProjects />
                </Drawer>
              </>
            )}
            <Content
              style={{
                background: bgBody,
              }}
              className="site-layout-content"
            >
              {children}
            </Content>
            <style>{`
              /* Default Mobile (<768px): Padding handled by Container (16px) */
              .site-layout-content {
                padding-left: 0px;
                padding-right: 0px;
              }

              /* Tablet (768px - 1200px) */
              @media (min-width: 768px) and (max-width: 1200px) {
                .site-layout-content {
                  padding-left: ${showSidebarProjects ? "24px" : "0px"} !important;
                  padding-right: ${showSidebarProjects ? "24px" : "0px"} !important;
                }
              }

              /* Desktop (>1200px) */
              @media (min-width: 1201px) {
                .site-layout-content {
                  padding-left: ${showSidebarProjects ? "40px" : "0px"} !important;
                  padding-right: 0px !important;
                }
              }
            `}</style>
          </Layout>
        )}
      </Container>
      <AppFooter>
        <FooterUser />
      </AppFooter>
    </Layout>
  );
};

export default memo(MasterLayout);
